import React from "react";
import {RouterProvider, createBrowserRouter, useRouteError} from "react-router-dom";
import {AdminFrame} from "./components/admin-frame/AdminFrame";
import {AdminFrameRoot} from "./components/admin-frame/AdminFrameRoot";
import {LoginPage} from "./components/login/LoginPage";
import {Constants} from "./components/common/Constants";
import {BrokerReportPage} from "./components/broker-reports/BrokerReportPage";
import {BrokerReportsListPage} from "./components/broker-reports/BrokerReportsListPage";
import {PublicBrokerPlanPage} from "./components/broker-reports/PublicBrokerPlanPage";
import {BrokersListPage} from "./components/brokers/BrokersListPage";
import {CreateBrokerPage} from "./components/brokers/CreateBrokerPage";
import {UpdateBrokerPage} from "./components/brokers/UpdateBrokerPage";
import {UsersListPage} from "./components/users/UsersListPage";
import {CreateUserPage} from "./components/users/CreateUserPage";
import {UpdateUserPage} from "./components/users/UpdateUserPage";
import {ChangePasswordPage} from "./components/users/ChangePasswordPage";
import {NewAccountSetupPage} from "./components/users/NewAccountSetupPage";
import {AccountActivatedPage} from "./components/users/AccountActivatedPage";
import {ForgotPasswordPage} from "./components/users/ForgotPasswordPage";
import {DispatchOrdersListPage} from "./components/dispatch-orders/DispatchOrdersListPage";
import {UpdateDispatchOrderPage} from "./components/dispatch-orders/UpdateDispatchOrderPage";
import {CreateDispatchOrderPage} from "./components/dispatch-orders/CreateDispatchOrderPage";
import {JobsListPage} from "./components/jobs/JobsListPage";
import {JobDetailPage} from "./components/jobs/JobDetailPage";
import {DashboardPage} from "./components/dashboard/DashboardPage";
import {RootErrorDisplay} from "./components/common/RootErrorDisplay";
import {NotFoundPage} from "./components/common/NotFoundPage";
import {SettingsFrame} from "./components/settings/SettingsFrame";
import {ActivityScopesListPage} from "./components/settings/ActivityScopesListPage";
import {ActivityMaterialsListPage} from "./components/settings/ActivityMaterialsListPage";
import {CreateActivityScopePage} from "./components/settings/CreateActivityScopePage";
import {UpdateActivityScopePage} from "./components/settings/UpdateActivityScopePage";
import {CreateActivityMaterialPage} from "./components/settings/CreateActivityMaterialPage";
import {UpdateActivityMaterialPage} from "./components/settings/UpdateActivityMaterialPage";

export default (
    <RouterProvider router={
        createBrowserRouter([
            {
                path: '/login',
                Component: LoginPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/forgot-password',
                Component: ForgotPasswordPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/change-password/:username/:token',
                Component: ChangePasswordPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/new-account-setup/:username/:token',
                Component: NewAccountSetupPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/plans/:token',
                Component: PublicBrokerPlanPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/account-activated',
                Component: AccountActivatedPage,
                ErrorBoundary: RootErrorBoundary
            },
            {
                path: '/',
                Component: AdminFrame,
                ErrorBoundary: RootErrorBoundary,
                children: [
                    {
                        index: true,
                        Component: AdminFrameRoot
                    },
                    {
                        path: Constants.routes.dashboard.pathSegment,
                        Component: DashboardPage,
                    },
                    {
                        path: Constants.routes.dispatch.pathSegment,
                        Component: DispatchOrdersListPage,
                    },
                    {
                        path: `${Constants.routes.dispatch.pathSegment}/dispatch-orders/:dispatchOrderId`,
                        element: <UpdateDispatchOrderPage showingNotificationModal={false}/>,
                    },
                    {
                        path: `${Constants.routes.dispatch.pathSegment}/dispatch-orders/:dispatchOrderId/notify`,
                        element: <UpdateDispatchOrderPage showingNotificationModal={true}/>,
                    },
                    {
                        path: `${Constants.routes.dispatch.pathSegment}/dispatch-orders/add`,
                        Component: CreateDispatchOrderPage,
                    },
                    {
                        path: Constants.routes.brokerReports.pathSegment,
                        Component: BrokerReportsListPage,
                    },
                    {
                        path: `${Constants.routes.brokerReports.pathSegment}/:brokerId/:dateString`,
                        Component: BrokerReportPage,
                    },
                    {
                        path: Constants.routes.jobs.pathSegment,
                        Component: JobsListPage,
                    },
                    {
                        path: `${Constants.routes.jobs.pathSegment}/:jobId`,
                        Component: JobDetailPage,
                    },
                    {
                        path: Constants.routes.brokers.pathSegment,
                        Component: BrokersListPage,
                    },
                    {
                        path: `${Constants.routes.brokers.pathSegment}/add`,
                        Component: CreateBrokerPage,
                    },
                    {
                        path: `${Constants.routes.brokers.pathSegment}/:brokerId`,
                        Component: UpdateBrokerPage,
                    },
                    {
                        path: Constants.routes.users.pathSegment,
                        Component: UsersListPage,
                    },
                    {
                        path: `${Constants.routes.users.pathSegment}/add`,
                        Component: CreateUserPage,
                    },
                    {
                        path: `${Constants.routes.users.pathSegment}/:userId`,
                        Component: UpdateUserPage,
                    },
                    {
                        path: Constants.routes.settings.pathSegment,
                        Component: SettingsFrame,
                        children: [
                            {
                                index: true,
                                Component: ActivityScopesListPage,
                            },
                            {
                                path: 'activity-scopes',
                                Component: ActivityScopesListPage,
                            },
                            {
                                path: 'activity-scopes/add',
                                Component: CreateActivityScopePage,
                            },
                            {
                                path: 'activity-scopes/:activityScopeId',
                                Component: UpdateActivityScopePage,
                            },
                            {
                                path: 'activity-materials',
                                Component: ActivityMaterialsListPage,
                            },
                            {
                                path: 'activity-materials/add',
                                Component: CreateActivityMaterialPage,
                            },
                            {
                                path: 'activity-materials/:activityMaterialId',
                                Component: UpdateActivityMaterialPage,
                            },
                        ],
                    },
                    {
                        path: '*',
                        Component: NotFoundPage,
                    }
                ]
            }
        ])
    }/>
);

function RootErrorBoundary() {
    let error = useRouteError();
    return <RootErrorDisplay error={error} />;
}
